/**
 * Models a Healthcare name field where the name is automatically generated from first name, middle name, last name and office name
 *
 *  @author Paige Ponzeka (pponzeka@yext.com)
 */

goog.module('yext.location.HealthcareName');
goog.module.declareLegacyNamespace();

const helpers = goog.require('yext.location.helpers');
const textfield = goog.require('yext.textfield');

/**
 * @constructor
 * @param {!jQuery} $ctx the container context
 */
const HealthcareName = function($ctx) {
  this.$ctx = $ctx;
  this.$indeterminate = this.$ctx.find('.js-field-indeterminate');
  this.firstName = textfield.createWithUsageType($ctx.find('.js-first-name .js-text-field'), 'location.first_name');
  this.middleName = textfield.createWithUsageType($ctx.find('.js-middle-name .js-text-field'), 'location.middle_name');
  this.lastName = textfield.createWithUsageType($ctx.find('.js-last-name .js-text-field'), 'location.last_name');
  this.officeName = textfield.createWithUsageType($ctx.find('.js-office-name .js-text-field'), 'location.office_name');
  this.healthcareName = textfield.createWithUsageType($ctx.find('.js-healthcare-name .js-text-field'), 'location.business_name');
  this.$timestamp = this.$ctx.find('.js-field-timestamp');

  // initialize whether the field is using a generated name
  this.isGeneratedName = this.hasGeneratedName();
  this.bind();
  this.storeValue();
};


/**
 * When the User types into the name fields, automatically update the healthcare name field
 */
HealthcareName.prototype.bind = function() {
  var self = this;
  // bind the text fields for editing
  $(this.firstName).on('update.textField', function() {
    self.setGenerated();
  });

  $(this.middleName).on('update.textField', function() {
    self.setGenerated();
  });

  $(this.lastName).on('update.textField', function() {
    self.setGenerated();
  });

  $(this.officeName).on('update.textField', function() {
    self.setGenerated();
  });

  this.bindHealthcareNameEdit();
};

/**
 * when the Healthcare name is edited
 */
HealthcareName.prototype.bindHealthcareNameEdit = function() {
  var self = this;
  $(this.healthcareName).on('update.textField', function() {
    self.onHealthcareNameEdit();
  });
};

/**
 * Response to when the healthcare Name is edited
 */
HealthcareName.prototype.onHealthcareNameEdit = function() {
  var healthcareNameValue = this.healthcareName.value().trim();
  this.isGeneratedName = this.hasGeneratedName();

  if (healthcareNameValue === '') {
    this.isGeneratedName = true;
    if (!this.generateName().trim() === '') {
      this.setGenerated();
    }
  } else if (!this.isGeneratedName) {
    this.message('updated');
  }
};

/**
 * Sets the generated HealthcareName
 */
HealthcareName.prototype.setGenerated = function() {
  // if we aren't using a generatedName, do nothing
  if (!this.isGeneratedName) {
    this.message('updated');
    return;
  }

  var data = {
    'value': this.generateName(),
  };

  this.healthcareName.set(data);
  this.message('updated');
};

/**
 * Get the display value of the field (view mode)
 */
HealthcareName.prototype.getDisplayValue = function() {
  if (this.healthcareName.model.indeterminate) {
    return helpers.variousContentMessage();
  } else if (!this.healthcareName.model.displayValue) {
    return helpers.emptyFieldMessage();
  } else {
    return this.healthcareName.viewMarkup();
  }
};

/**
 * Set the select element value and trigger a change event
 *
 * @param {!Object} value
 */
HealthcareName.prototype.set = function(field) {
  if (!field) {
    this.reset();
  }

  this.firstName.set(field['location.first_name']);
  this.middleName.set(field['location.middle_name']);
  this.lastName.set(field['location.last_name']);
  this.officeName.set(field['location.office_name']);
  this.healthcareName.set(field['location.business_name']);
};

/**
 * Reset the field to the stored state
 */
HealthcareName.prototype.reset = function() {
  this.firstName.reset();
  this.middleName.reset();
  this.lastName.reset();
  this.officeName.reset();
  this.healthcareName.reset();
};

/**
 * Publish a message with the field as the context
 * @param {string} msg The Message to send
 */
HealthcareName.prototype.message = function(msg) {
  $(this).trigger(msg);
};

/**
 * Generates the healthcare name from first name, middle name, last name, office name
 */
HealthcareName.prototype.generateName = function() {
  var firstName = this.firstName.value();
  var middleName = this.middleName.value();
  var lastName = this.lastName.value();
  var officeName = this.officeName.value();
  var healthcareName = firstName;

  // make sure the names aren't empty before adding them
  if (this.isNotEmpty(middleName)) {
    healthcareName += ' ' + middleName;
  }

  if (this.isNotEmpty(lastName)) {
    healthcareName += ' ' + lastName;
  }

  if (this.isNotEmpty(officeName)) {
    healthcareName += ' - ' + officeName;
  }
  if (healthcareName) {
    healthcareName = healthcareName.trim();
  }
  return healthcareName;
};

/**
 * Checks whether a string is empty
 * @param  {string} text input string
 * @return {boolean} boolean indicating whether a string is or is not empty
 */
HealthcareName.prototype.isNotEmpty = function(text) {
  return $.trim(text) !== '';
};

/**
 * Checkes whether the healthcareName matches the generated format
 * @return {boolean} returns true if the generatedName matches the healthcareName
 */
HealthcareName.prototype.hasGeneratedName = function() {
  var generatedName = this.generateName();
  var healthcareName = this.healthcareName.value();

  if (healthcareName) {
    healthcareName = healthcareName.trim();
  }

  return generatedName === healthcareName;
};

/**
 * Store the value so that it can be restored later
 */
HealthcareName.prototype.storeValue = function() {
  this.firstName.saveValue();
  this.middleName.saveValue();
  this.lastName.saveValue();
  this.officeName.saveValue();
  this.healthcareName.saveValue();
};

exports = HealthcareName;
